import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveCentralOperacoes({ name, actived }) {
  try {
    const response = await authHttp().post(routes.urlPostCentralOperacoes, { name, actived })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function updateCentralOperacoes({ id, name, actived }) {
  try {
    const response = await authHttp().put(routes.urlPutCentralOperacoes(id), { name, actived })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getCentralOperacoes() {
  try {
    const response = await authHttp().get(routes.urlGetCentralOperacoes)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
